<template>
	<div class="seller-buyout">
		<div class="btnbox">
			<el-button size="small" @click="goStock">在仓库存</el-button>
			<el-button size="small" @click="goSettle">结算中心</el-button>
		</div>
		<div class="tablebox">
			<div class="filterdiv filterty" ref="filter">
				<el-form :inline="true" size="small" label-width="0">
					<el-form-item>
						<el-radio-group v-model="formfilter.state" @change="onfilter">
							<el-radio-button label="">全部</el-radio-button>
							<el-radio-button label="0">待应答</el-radio-button>
							<el-radio-button label="1">已成交</el-radio-button>
							<el-radio-button label="2">已拒绝</el-radio-button>
							<el-radio-button label="3">已失效</el-radio-button>
						</el-radio-group>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onlist">刷新</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="tablediv" ref="tablediv">
				<el-table :data="list" style="width: 100%" border height="100%" v-loading="loading">
					<el-table-column type="expand">
						<template slot-scope="scope">
							<el-table :data="scope.row.items" border size="mini" style="width: 100%">
								<el-table-column prop="style_number" label="款号" min-width="110"></el-table-column>
								<el-table-column prop="size" label="尺码" width="60" align="center"></el-table-column>
								<el-table-column label="报价数" width="70" align="center">
									<template slot-scope="s">{{ s.row.quantity }}</template>
								</el-table-column>
								<el-table-column label="成交数" width="70" align="center">
									<template slot-scope="s">{{ scope.row.state == 1 ? s.row.deal_quantity : '--' }}</template>
								</el-table-column>
								<el-table-column label="到手单价" width="90" align="center">
									<template slot-scope="s">¥{{ s.row.buyout_price_str }}</template>
								</el-table-column>
								<el-table-column label="到手折扣" width="80" align="center">
									<template slot-scope="s">{{ zhe(s.row.buyout_discount_str) }}</template>
								</el-table-column>
								<el-table-column label="供货折扣" width="80" align="center">
									<template slot-scope="s">{{ zhe(s.row.supply_discount_str) }}</template>
								</el-table-column>
								<el-table-column label="让利" width="70" align="center">
									<template slot-scope="s">{{ zhe(s.row.discount_gap_str) }}</template>
								</el-table-column>
								<el-table-column label="当前折扣" width="80" align="center">
									<template slot-scope="s">{{ s.row.current_supply_discount_str ? zhe(s.row.current_supply_discount_str) : '--' }}</template>
								</el-table-column>
								<el-table-column label="预估可成" width="80" align="center">
									<template slot-scope="s">
										<span :class="{ 'gap-tip': scope.row.state == 0 && s.row.deal_estimate < s.row.quantity }">{{ s.row.deal_estimate }}</span>
									</template>
								</el-table-column>
								<el-table-column label="当前可用" width="80" align="center">
									<template slot-scope="s">{{ s.row.available_quantity }}</template>
								</el-table-column>
							</el-table>
							<div class="item-tip" v-if="scope.row.state == 0 && hasDealGap(scope.row)">
								红色数字：该行期间部分售出，同意后将按当前可用数量部分成交（其余自动跳过）。
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="id" label="报价单ID" width="90" align="center"></el-table-column>
					<el-table-column prop="buyer_username" label="买家" min-width="100" align="center"></el-table-column>
					<el-table-column label="款号" min-width="140" align="center">
						<template slot-scope="scope">{{ styleSummary(scope.row) }}</template>
					</el-table-column>
					<el-table-column label="入仓折扣" width="90" align="center">
						<template slot-scope="scope">{{ sameDiscount(scope.row, 'supply_discount_str') }}</template>
					</el-table-column>
					<el-table-column label="到手折扣" width="90" align="center">
						<template slot-scope="scope">{{ sameDiscount(scope.row, 'buyout_discount_str') }}</template>
					</el-table-column>
					<el-table-column label="报价件数" width="90" align="center">
						<template slot-scope="scope">{{ scope.row.total_quantity }}</template>
					</el-table-column>
					<el-table-column label="到手合计" width="110" align="center">
						<template slot-scope="scope">¥{{ scope.row.total_buyout_str }}</template>
					</el-table-column>
					<el-table-column label="状态" width="90" align="center">
						<template slot-scope="scope">
							<span :class="'state-text state-' + scope.row.state">{{ scope.row.state_str }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="create_time_str" label="报价时间" width="160" align="center"></el-table-column>
					<el-table-column prop="handle_time_str" label="处理时间" width="160" align="center"></el-table-column>
					<el-table-column label="操作" fixed="right" width="130" align="center">
						<template slot-scope="scope">
							<div class="operation_i" v-if="scope.row.state == 0">
								<span @click="onAgree(scope.row)">同意</span>
								<span @click="onReject(scope.row)">拒绝</span>
							</div>
							<span v-else>--</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="pagediv">
				<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100, 200]"
					:current-page.sync="page" :page-size="pageSize" :total="total" v-if="total > 0"
					@current-change="handleCurrentChange" @size-change="handleSizeChange">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import { fenToYuan, apiMsg } from './money.js'

	export default {
		name: 'SellerWarehouseBuyout',
		data() {
			return {
				list: [],
				page: 1,
				pageSize: 20,
				total: 0,
				loading: false,
				formfilter: {
					state: ''
				}
			}
		},
		mounted() {
			this.onlist()
			this.resizeObserver = new ResizeObserver(entries => {
				for (let entry of entries) {
					const cr = entry.contentRect
					if (this.$refs.tablediv) {
						this.$refs.tablediv.style.height = 'calc(100% - ' + (Number(cr.height) + 30) + 'px)'
					}
				}
			})
			if (this.$refs.filter) {
				this.resizeObserver.observe(this.$refs.filter)
			}
		},
		beforeDestroy() {
			if (this.resizeObserver) {
				this.resizeObserver.disconnect()
			}
		},
		methods: {
			fenToYuan: fenToYuan,
			zhe(val) {
				// 接口 *_str 为「折数两位小数字符串」（如 "4.50"），去掉尾零展示
				var num = parseFloat(val)
				return isNaN(num) ? '--' : num + '折'
			},
			styleSummary(row) {
				var names = []
				;(row.items || []).forEach(function(item) {
					var name = item.style_number || ''
					if (name && names.indexOf(name) === -1) {
						names.push(name)
					}
				})
				if (!names.length) {
					return '--'
				}
				if (names.length <= 2) {
					return names.join(' / ')
				}
				return names[0] + ' 等 ' + names.length + ' 款'
			},
			sameDiscount(row, key) {
				var items = row.items || []
				if (!items.length) {
					return '--'
				}
				var first = items[0][key]
				var mixed = items.some(function(item) {
					return String(item[key] || '') !== String(first || '')
				})
				return mixed ? '--' : this.zhe(first)
			},
			hasDealGap(row) {
				var items = row.items || []
				return items.some(function(item) {
					return Number(item.deal_estimate || 0) < Number(item.quantity || 0)
				})
			},
			goStock() {
				this.$router.push('/seller/warehouse/stock')
			},
			goSettle() {
				this.$router.push('/seller/warehouse/settle')
			},
			onfilter() {
				this.page = 1
				this.onlist()
			},
			handleCurrentChange() {
				this.onlist()
			},
			handleSizeChange(val) {
				this.page = 1
				this.pageSize = val
				this.onlist()
			},
			onlist() {
				this.loading = true
				var params = {
					type: 2,
					page: this.page,
					limit: this.pageSize
				}
				if (this.formfilter.state !== '' && this.formfilter.state !== null) {
					params.state = this.formfilter.state
				}
				this.$axios.get('api/cloud_warehouse/buyout_offer_list', { params: params }).then(res => {
					this.loading = false
					if (res.data.code === 0) {
						var data = res.data.data || {}
						this.list = data.list || []
						this.total = data.count || 0
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					this.loading = false
					console.log(err)
				})
			},
			onAgree(row) {
				if (Number(row.state) !== 0) {
					return
				}
				var tip = '将按报价快照成交：到手合计 ¥' + row.total_buyout_str + '。'
				if (this.hasDealGap(row)) {
					tip += '注意：部分库存期间已售出，将按当前可用数量部分成交（其余自动跳过）。'
				}
				tip += '确认后货权归买家、不可撤销，到手金额实时计入可提现余额。'
				this.$confirm(tip, '确认同意该变现报价？', {
					confirmButtonText: '确认成交',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$axios.post('api/cloud_warehouse/buyout_respond', {
						id: row.id,
						state: 1
					}).then(res => {
						if (res.data.code === 0) {
							var data = res.data.data || {}
							var diffTip = Number(data.deal_quantity) < Number(data.total_quantity)
								? '（原报价 ' + data.total_quantity + ' 件，实际成交 ' + data.deal_quantity + ' 件）'
								: ''
							this.$alert('成交 ' + data.deal_quantity + ' 件' + diffTip + '，到手金额 ¥' + this.fenToYuan(data.deal_buyout) + ' 已计入可提现余额，可前往结算中心提现。', '即时变现成功', {
								confirmButtonText: '知道了'
							}).catch(() => {})
							this.onlist()
						} else {
							this.$message.error(apiMsg(res))
						}
					}).catch(err => {
						console.log(err)
					})
				}).catch(() => {})
			},
			onReject(row) {
				if (Number(row.state) !== 0) {
					return
				}
				this.$prompt('拒绝后该报价单关闭，买家将收到通知。可填写拒绝原因（选填，不超过255字）：', '拒绝变现报价', {
					confirmButtonText: '确认拒绝',
					cancelButtonText: '取消',
					inputPlaceholder: '拒绝原因（选填）',
					inputValidator: function(val) {
						return (val || '').length <= 255 || '拒绝原因不能超过255位'
					}
				}).then(({ value }) => {
					this.$axios.post('api/cloud_warehouse/buyout_respond', {
						id: row.id,
						state: 2,
						reject_reason: value || ''
					}).then(res => {
						if (res.data.code === 0) {
							this.$message.success('已拒绝该报价')
							this.onlist()
						} else {
							this.$message.error(apiMsg(res))
						}
					}).catch(err => {
						console.log(err)
					})
				}).catch(() => {})
			}
		}
	}
</script>

<style scoped lang="less">
	.seller-buyout {
		height: 100%;
	}

	.tablebox {
		height: calc(100% - 72px);
	}

	.state-text {
		&.state-0 { color: #E6A23C; }
		&.state-1 { color: #67C23A; }
		&.state-2 { color: #909399; }
		&.state-3 { color: #909399; }
	}

	.gap-tip {
		color: #F56C6C;
		font-weight: 600;
	}

	.item-tip {
		color: #F56C6C;
		font-size: 12px;
		line-height: 22px;
		margin-top: 8px;
	}
</style>



// WEBPACK FOOTER //
// src/components/seller/warehouse/buyout.vue